// The radio's screens (docs/spec/radio.md): in the staff app a Radio tab, a slim bar on Now and one
// engine wrapped around the whole app so it keeps running between tabs; in the console a floating
// hold-to-talk button. The door kiosk's listen-only switch is still built into the kiosk app.
import type { ReactNode } from "react";
import { api, navigate, radioSocket, RadioButton, type UiPart } from "@vavr/screens/shared";
import { T, useTeacher } from "@vavr/screens/teacher";
import { RadioBar, RadioPanel, RadioProvider } from "./staff.tsx";

/** The staff app's radio engine, for the site the teacher is working at. */
function StaffRadio({ children }: { children: ReactNode }) {
  const { site, platform } = useTeacher();
  return (
    <RadioProvider
      channelKey={site.id} engine={platform.radioEngine}
      getTicket={(pass) => api<{ ticket: string; pass?: string }>("POST", `/api/v1/sites/${site.id}/radio-ticket`, { pass })}
      wsBase={radioSocket(platform.apiBase, site.id)}
    >
      {children}
    </RadioProvider>
  );
}

export const radioUi: UiPart = {
  id: "radio",
  slots: {
    "staff.wrap": [{ id: "radio", wrap: (children) => <StaffRadio>{children}</StaffRadio> }],
    "staff.tab": [{ id: "radio", label: "Radio", icon: "mic", path: "radio", title: "Radio", after: "class", render: () => <RadioPanel /> }],
    "staff.footer": [{ id: "radio", tabs: ["now"], render: () => <RadioBar onOpen={() => navigate(`${T}/radio`)} /> }],
    "console.overlay": [{
      id: "radio", permission: "radio:use",
      render: ({ siteId }) => (
        <RadioButton channelKey={siteId} wsBase={radioSocket("", siteId)}
          getTicket={(pass) => api<{ ticket: string; pass?: string }>("POST", `/api/v1/sites/${siteId}/radio-ticket`, { pass })} />
      ),
    }],
  },
};
